<template>
  <div>
    <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100%;
        top: 0px;
      "
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
      class="d-none d-sm-flex"
    >
      <div style="width: 100%" class="mt-5 m-0">
        <h3 class="text-center text-white m-0">
          These are replied message by tutor who want to apply for the job
        </h3>
        <br /><br />
      </div>
    </div>
    <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100%;
        top: 0px;
      "
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
      class="d-flex d-sm-none"
    >
      <div style="width: 100%" class="mt-3">
        <CCol sm="12">
          <span @click="GoToPageNotification()">
            <!-- <CIcon name="cil-envelope-closed" class="float-right mr-3" /> -->
            <br />
            <img
              src="../assets/img/iconInbox.png"
              width="40px"
              class="float-right mr-2 mt-2"
            />
          </span>

          <span class="mt-5 mb-5"> </span>
          <br /><br />
          <br /><br />
          <br /><br />
          <br /><br />
        </CCol>
      </div>
    </div>

    <CCard class="custom-card h-100">
      <CCol sm="12" class="justify-content-center m-0">
        <CContainer>
          <CCol sm="12" lg="12" class="custom-margin m-0 p-0">
            <h4 class="text-left mt-2 d-flex d-sm-none text-black bold">
              Tutor messages
            </h4>
            <div class="mt-2">
              <label @click="OpenPopupInfo()">
                Click here for further info
                <img
                  src="../assets/img/iconInfo.png"
                  width="20px"
                  height="20px"
                  class="mr-2"
              /></label>
            </div>
             <CCard v-if="!profiles.length">
              <div class="mt-5 text-center mb-5">
              <img src="../assets/img/nodata.png" width="120px"/>
              <br />
              No notification yet
              </div>
            </CCard>
          
            <CCol
              sm="12"
              v-for="item in profiles.slice(0, 1)"
              v-bind:key="item.Id"
              class="mt-4 p-0"
            >
              <h6>Subject : {{ item.Subject }}</h6>
              <h6>Level : {{ item.Level }}</h6>
            </CCol>


            <CCard
              v-for="(item, index) in profiles"
              v-bind:key="item.Id"
              class="p-2 d-none d-sm-flex mt-2"
            >
              <CCol>
                <CRow
                  @click="GoToPageResponse(index)"
                  sm="10"
                  lg="10"
                  class="mx-auto d-flex justify-content-center"
                >
                  <CCol sm="1" lg="1">
                    <div class="p-2">
                      <img
                        width="30"
                        height="30"
                        src="../assets/img/notifications.png"
                      />
                    </div>
                  </CCol>
                  <CCol sm="11" lg="11" class="float-right">
                    <CRow>
                      <CCol sm="9" lg="9">
                         <strong>Job ({{ item.FindTutorId }})</strong>
                          <br />
                        <CBadge color="primary">{{ item.SubjectName }}</CBadge>
                        <br />
                        <label>{{ item.Description }}</label>
                        <br />
                      </CCol>
                      <CCol sm="3" lg="3">
                        <strong class="mt-5">
                          <i>{{ item.CreatedTime }}</i></strong
                        >
                      </CCol>
                    </CRow>
                  </CCol>
                </CRow>
              </CCol>
            </CCard>

            <CCard
              v-for="(item, index) in profiles"
              v-bind:key="item.Id"
              class="p-2 d-flex d-sm-none"
              style="margin-bottom: 0.7em"
            >
              <CCol class="p-0">
                <CRow
                  @click="GoToPageResponse(index)"
                  sm="10"
                  lg="10"
                  class="mx-auto d-flex justify-content-center"
                >
                  <CCol sm="12" lg="12">
                    <div>
                      <img
                        width="30"
                        height="30"
                        src="../assets/img/notifications.png"
                        class="mr-3"
                      />
                        <strong>Job ({{ item.FindTutorId }})</strong>
                        <br />
                      Applicant
                      <CBadge color="primary">{{ item.SubjectName }}</CBadge>
                      <br />
                      <label class="float-left">{{ item.Description }}</label>
                      <br />
                      <strong class="small text-muted float-right">
                        {{ item.CreatedTime }}</strong
                      >
                    </div>
                  </CCol>
                </CRow>
              </CCol>
            </CCard>
          </CCol>
        </CContainer>
      </CCol>
    </CCard>
    <CModal title="Info" size="sm" color="info" :show.sync="InfoModal" hide-footer>
      <CCol sm="12">
        <div>
          <label><strong>Info</strong></label>
          <p>
            These are replied message by tutor who want to apply for the job.
            Once you accept one of them and they agreed, the others will
            automatically rejected.
          </p>
        </div>
      </CCol>
      <template class="modal-footer" hidden="true" #footer>
         <span
                    ></span
                  >
         </template>
    </CModal>
  </div>
</template>


<script>
import backgroundBanner from "../assets/img/bgApps.jpg";
export default {
  name: "Login",
  data() {
    return {
      backgroundBanner,
      profiles: [],
      notify: [],
      InfoModal: false,
    };
  },
  async mounted() {
    await this.GetNotificationStudent();
  },
  methods: {
    OpenPopupInfo() {
      this.InfoModal = true;
    },
    async GetNotificationStudent() {
      this.$API
        .get(
          this.$RequestNotificationStudent +
            "?userId=" +
            this.$route.query.userId +
            "&&subjectId=" +
            this.$route.query.subjectId +
            "&&levelId=" +
            this.$route.query.levelId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.profiles = response.data;
          }
        });
    },

    GoToPageNotificationResponse(index) {
      this.$router.push(
        "/StudentSchedule?notiId=" + this.profiles[index].NotiId
      );
    },
    GoToPageResponse(index) {
      this.$router.push(
        "/StudentResponse?notiId=" + this.profiles[index].NotiId
      );
    },
    GoToPageNotification(index) {
      this.$router.push("/Request?userId=" + this.$route.query.userId);
    },
  },
};
</script>
